<template>
  <div>
    <div class="cmp-preview" v-for="key in resourcesList" :key="key">
      <strong>{{ resourcesExtended[key].descriptionWithPath }}</strong>
      <br />
      <div class="cmp-preview-block" v-if="previewDiffsLabels[key].permit.length">
        <i>Consenti:</i>
        <div class="cmp-actions" v-html="previewDiffsLabels[key].permit"></div>
        <br />
      </div>
      <div class="cmp-preview-block" v-if="previewDiffsLabels[key].forbid.length">
        <i>Nega:</i>
        <div class="cmp-actions" v-html="previewDiffsLabels[key].forbid"></div>
        <br />
      </div>
      <br />
    </div>
  </div>
</template>
<script>
export default {
  name: 'copyPreviewer',
  props: {
    resourcesList: { type: Array },
    previewDiffs: Object,
    resourcesExtended: Object,
  },
  computed: {
    // Returns eg.
    // {
    //   "UserBuAbsence": {
    //     "permit": ["<span style=\"color: #EF7B12;\">Creazione</span>", ...],
    //     "forbid": ["<span>Cancellazione</span>", ...]
    //   },
    //   ...
    // }
    previewDiffsLabels() {
      const actionTag = (key, action, changed) => {
        const style = changed ? ' style="color: #EF7B12;"' : '';
        return `<span${style}>${this.resourcesExtended[key].actions[action]}</span>`;
      };
      return Object.keys(this.previewDiffs).reduce((obj, key) => {
        const diffs = this.previewDiffs[key];
        return {
          ...obj,
          [key]: {
            permit: [
              ...diffs.permit.diff.map((action) => actionTag(key, action, 'cmp-changed')),
              ...diffs.permit.same.map((action) => actionTag(key, action, '')),
            ].join(', '),
            forbid: [
              ...diffs.forbid.diff.map((action) => actionTag(key, action, 'cmp-changed')),
              ...diffs.forbid.same.map((action) => actionTag(key, action, '')),
            ].join(', '),
          },
        };
      }, {});
    },
  },
  watch: {
    origin: 'watchOriginsDestinationChanges',
    destination: 'watchOriginsDestinationChanges',
  },
};
</script>
<style scoped>
.mb-3 {
  margin-bottom: 10px;
}
.cmp-preview {
  font-size: 14px;
}
.cmp-preview-block {
  margin-left: 20px;
}
.cmp-actions {
  display: inline;
}
</style>
